import React, { useState, useEffect, useRef } from 'react';
import UserCard from './UserCard';
import NewUserCard from './NewUserCard';
import {
    Row, Col,
    InputGroupText, Input, InputGroup, InputGroupAddon, FormGroup
} from 'reactstrap';
import { getUsers, saveUser, addUser, deleteUser, addAccountUser } from '../../API';

function Users(props) {
    const [users, setUsers] = useState([]);
    const [allUsers, setAllUsers] = useState([]);
    const [isLoadingUsers, setIsLoadingUsers] = useState(true);

    const [newUsers, setNewUsers] = useState([]);
    const [searchOptions, setSearchOptions] = useState(props.defaultSearch || {});
    const [searchTimeout, setSearchTimeout] = useState(false);
    const searchOptionsRef = useRef(searchOptions);
    const searchTimeoutRef = useRef(searchTimeout);
    searchOptionsRef.current = searchOptions;
    searchTimeoutRef.current = searchTimeout;

    useEffect(() => {
        fetchUsers();
    }, []);

    useEffect(() => {
        const timeoutSearch = async () => {
            await search();
        };

        const timeout = setTimeout(timeoutSearch, 500);

        return (() => clearTimeout(timeout));
    }, [searchOptions]);

    const fetchUsers = async () => {
        setAllUsers(await getUsers());
    }

    const search = async () => {
        setIsLoadingUsers(true);

        const searchAPIResults = await getUsers(searchOptionsRef.current);
        setUsers(searchAPIResults.sort((a, b) => (a.emailAddress > b.emailAddress) ? 1 : ((b.emailAddress > a.emailAddress) ? -1 : 0)));

        setIsLoadingUsers(false);
    };

    const getNewUserId = () => {
        return newUsers.map(u => u.userID).reduce((a, b) => (a > b) ? a : b, 0) + 1;
    };

    const addNewUser = () => {
        const tempId = getNewUserId();
        const newUser = { userID: tempId, emailAddress: '' };
        setNewUsers([newUser, ...newUsers]);
    };

    const removeNewUser = (userId) => {
        const tempNewUsers = [...newUsers];
        const removeIndex = tempNewUsers.findIndex(u => u.userID === userId);
        tempNewUsers.splice(removeIndex, 1);
        setNewUsers(tempNewUsers);
    };

    const saveNewUser = async (newUser) => {
        const addableUser = {
            ...newUser,
            
        };
        delete addableUser.userID;

        const savedUser = await addUser(addableUser);
        console.log(savedUser);
        if (props.addConnection)
            await props.addConnection(savedUser.userID);

        removeNewUser(newUser.userID);

        search();
    };

    const updateNewUser = (newUser, e) => {
        const tempNewUsers = [...newUsers];
        const updateIndex = tempNewUsers.findIndex(u => u.userID === newUser.userID);
        tempNewUsers[updateIndex] = { ...tempNewUsers[updateIndex], [e.target.name]: e.target.value }
        setNewUsers(tempNewUsers);
    };

    const removeUser = async (userId) => {
        if (props.deleteConnection)
            await props.deleteConnection(userId);
        else
            await deleteUser(userId);

        search();
    };

    const updateSearch = e => {
        setSearchOptions({
            ...searchOptions,
            [e.target.name]: e.target.value
        });
    };

    let usersJSX = (<div>No users found.</div>);
    if (isLoadingUsers)
        usersJSX = (<div>Loading...</div>);
    else if (users.length > 0 || newUsers.length > 0)
        usersJSX = (
            <div>
                {newUsers?.map(u => (<NewUserCard key={u.userID} user={u} cancel={removeNewUser} save={saveNewUser} update={updateNewUser} allUsers={allUsers} />))}
                {users?.map(u => (<UserCard key={u.userID} user={u} delete={removeUser} />))}
            </div>
        );

    return (
        <div>
            <Row xs={2} md={2} lg={3} xl={4} className="justify-content-between search-row">
                <Col>
                    <FormGroup>
                        <InputGroup className="tooltip-parent">
                            <InputGroupAddon addonType="prepend">
                                <InputGroupText><i className="fas fa-envelope"></i></InputGroupText>
                            </InputGroupAddon>
                            <Input type="email" name="email" value={searchOptions.email || ''} placeholder="Email" onChange={updateSearch} />
                            <div className="tooltip-target">
                                User Email
                            </div>
                        </InputGroup>
                    </FormGroup>
                </Col>
                {window.env.user.userRoles.some(ur => [1, 2].includes(ur.roleID)) ? (
                    <Col>
                        <div onClick={addNewUser} className="action-icon action-add float-right tooltip-parent">
                            <i className="fas fa-plus"></i>
                            <div className="tooltip-target">
                                Add New User
                            </div>
                        </div>
                    </Col>
                ) : null}
            </Row>
            <Row>
                <Col>
                    {usersJSX}
                </Col>
            </Row>
        </div>
    );
}

export default Users;